export default __webpack_public_path__ + "static/media/27_Ds.614b9294.svg";